import React, { createContext, useState, useContext } from "react";
import { useHistory, Link } from "react-router-dom";

import { APIContext } from "../../../../context/";
import { Button } from "@material-ui/core";
import CustomToolbar from "../../../customToolbar";
import AddIcon from "@material-ui/icons/Add";
import CsvDownload from "react-json-to-csv";

export const PrecalificacionesContext = createContext();

const PrecalificacionesProvider = (props) => {
  const ruta_existe = ``;

  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    // ase_nombre: "",
    // password: "",
    // ase_tipide: "",
    // ase_numide: "",
    // ase_email: "",
    // ase_telefono: "",
    // ase_telefono2: "",
    // ase_rol: "",
    // ase_estado: "",
  });

  const [row, setRow] = useState({});

  const [editableObject, seteditableObject] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const { precalificaciones, unCheck, verificar_borrar } =
    useContext(APIContext);

  const headCells = [
    // Toma, tipo, pasajeros, cilindrada, combustible
    { id: "id", numeric: true, disablePadding: false, label: "#" },
    {
      id: "repleg_nombre",
      numeric: false,
      disablePadding: false,
      label: "Nombre Aplicante",
    },
    {
      id: "repleg_cedula",
      numeric: true,
      disablePadding: false,
      label: "RUC/CI Aplicante",
    },
    {
      id: "empresa_razsoc",
      numeric: false,
      disablePadding: false,
      label: "Razon social",
    },
    //{ id: 'ase_tipide_nom', numeric: true, disablePadding: false, label: 'Tipo de identificación' },
    {
      id: "empresa_ruc",
      numeric: false,
      disablePadding: false,
      label: "RUC Razon social",
    },
    { id: "email", numeric: false, disablePadding: false, label: "Email" },
    {
      id: "ventas_mes_promedio",
      numeric: false,
      disablePadding: false,
      label: "V.M.Anterior",
    },
    {
      id: "ventas_ano_curso",
      numeric: false,
      disablePadding: false,
      label: "V.A.Curso",
    },
    {
      id: "ventas_ano_anterior",
      numeric: true,
      disablePadding: false,
      label: "V.A.Anterior",
    },
    {
      id: "sect_nombre",
      numeric: false,
      disablePadding: false,
      label: "Sect.Económico",
    },
  ];

  const idName = "id";

  const data = precalificaciones;

  const tipo_ide = [
    { value: 1, tipo: "Cédula" },
    { value: 2, tipo: "RUC" },
    { value: 3, tipo: "Pasaporte" },
  ];

  const estado = [
    { value: 1, tipo: "Activo" },
    { value: 2, tipo: "Inactivo" },
  ];

  const rol = [
    { value: 1, tipo: "Desarrollador" },
    { value: 2, tipo: "Administrador" },
    { value: 3, tipo: "Colaborador" },
    { value: 4, tipo: "Atención al Cliente" },
  ];

  const columns = [
    {
      name: "id",
      label: "#",
      options: {
        sortDirection: "desc",
      },
    },
    { name: "repleg_nombre", label: "Nombre Aplicante" },
    { name: "repleg_cedula", label: "RUC/CI Aplicante" },
    { name: "empresa_razsoc", label: "Razon social" },
    { name: "empresa_ruc", label: "RUC Razon social" },
    { name: "empresa_email", label: "Email" },
    { name: "ventas_mes_promedio", label: "V.M.Promedio" },
    { name: "ventas_ano_anterior", label: "V.A.Anterior" },
    { name: "sect_nombre", label: "Sect.Económico" },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          const data = precalificaciones[dataIndex];

          return (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={(e) => {
                  //seteditableObject(data);
                  //handleDialogOpen();
                  sendRow(data.id, data);
                }}
              >
                Ver
              </Button>
            </>
          );
        },
      },
    },
  ];

  const options = {
    filter: true,
    filterType: "multiselect",
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: "Sorry, no matching records found",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "ver Columnas",
        filterTable: "Filtrar Tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "RESTABLECER",
      },
      viewColumns: {
        title: "Mostrar Columnas",
        titleAria: "Mostrar/Ocultar Columnas",
      },
      selectedRows: {
        text: "Registro(s) seleccionados",
        delete: "Eliminar",
        deleteAria: "Eliminar Registro(s) seleccionados",
      },
    },
    customToolbar: () => {
      return (
        <>
          <CsvDownload
            data={data}
            filename="precalificaciones.csv"
            style={{
              //pass other props, like styles
              backgroundColor: "inherit",
              borderRadius: "6px",
              border: "1px solid rgb(2, 68, 106)",
              display: "inline-block",
              cursor: "pointer",
              color: "rgb(2, 68, 106)",
              fontSize: "15px",
              //fontWeight:"bold",
              padding: "6px 24px",
              textDecoration: "none",
              //textShadow:"0px 1px 0px #fa8200",
              marginLeft: "1em",
              marginRight: "1em",
            }}
          >
            Descargar
          </CsvDownload>
        </>
      );
    },
    // onRowsDelete:(rowsDeleted) => {
    //     const array = rowsDeleted.data
    //     const DeleteId = array.map((arr,index)=>{
    //         return precalificaciones[arr.dataIndex].id
    //     })

    //     array.map((arr,index)=>{
    //         let id     = precalificaciones[arr.dataIndex].id
    //         let nombre = precalificaciones[arr.dataIndex].ase_nombre
    //         verificar_borrar(ruta_existe, id, nombre, DeleteId)
    //         .then(function(result) {
    //             if(result){
    //                 deleteAsesor(id, nombre, DeleteId);
    //             }
    //         });
    //         return arr
    //     })
    //     unCheck();
    //     return false
    // },
    // customToolbar: () => {
    //   return (
    //     <CustomToolbar Component={AsesorDialogForm} CustomIcon={AddIcon} />
    //   );
    // },
  };

  function sendRow(index, data) {
    setRow(data);
    if (data.estado === 0) {
      history.push(`precalificaciones/${index}`);
    }
    if (data.estado === 1) {
      history.push(`precalificaciones-aprobadas/${index}`);
    }
    if (data.estado === 2) {
      history.push(`precalificaciones-rechazadas/${index}`);
    }
  }

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const clearForm = () => {
    setForm({
      // ase_nombre: "",
      // password: "",
      // ase_tipide: "",
      // ase_numide: "",
      // ase_email: "",
      // ase_telefono: "",
      // ase_telefono2: "",
      // ase_rol: "",
      // ase_estado: "",
    });
  };

  return (
    <PrecalificacionesContext.Provider
      value={{
        form,
        open,
        headCells,
        idName,
        columns,
        options,
        data,
        dialogOpen,
        editableObject,
        tipo_ide,
        rol,
        estado,
        row,
        setRow,

        clearForm,
        setOpen,
        handleDialogOpen,
        handleDialogClose,
      }}
    >
      {props.children}
    </PrecalificacionesContext.Provider>
  );
};

export default PrecalificacionesProvider;
